<template>
  <div>
    <div class="none cursors float-right" @click="handleOpen">
      <i class="el-icon-info" style="font-size: 20px"></i>
    </div>
    <el-dialog
      :title="$t('info_climates.total_rain')"
      :visible.sync="modals.read"
      :close-on-click-modal="false"
    >
      <div class="mb-5" style="word-break: break-word">
        <p>
          <small>
            {{ $t('info_climates.total_rain_info') }}
          </small>
        </p>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: 'info-total-rain',
  data() {
    return {
      modals: {
        read: false,
      },
    };
  },
  methods: {
    handleOpen() {
      this.modals.read = true;
    },
  },
};
</script>
